import { Component } from "react";
import NavTab from "../../../components/common/global_layout/navTab";
import { Container, Row } from "reactstrap";
import SideBarVisa from "../../../components/common/Visas/sideBarVisa";

import "../../../style/css/particulier/sideBarResult.css";
import AnnounceRow from "../../../components/common/announceRow";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      /* Awesome State Not Yet Used */
    };
  }

  render() {
    return (
      <div
        className={`sidebar-menu${
          this.props.isMenuOpen === true ? " open" : ""
        }`}
      >
        <button
          type="button"
          className="close mt-1 mr-2"
          onClick={this.props.onMenuToggle}
        >
          <span aria-hidden="true">×</span>
        </button>
        <SideBarVisa />
      </div>
    );
  }
}


class AdvencedSearchVisa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: !(window.innerWidth<680),
      widthSideBar:(330 / window.innerWidth) * 100 ,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.resultSlider = this.resultSlider.bind(this);
  }

  componentWillMount() {
    this.resultSlider();
  }

  //slide result div with % compared to width menu (330px)
  resultSlider() {
    if (this.state.isMenuOpen === true) {
      if (window.innerWidth>1480) {
        this.setState({ widthSideBar:(330 / window.innerWidth) * 100 - 2});
      }
      else if(window.innerWidth<680){
        this.setState({widthSideBar:0});
      }
      else{
        this.setState({ widthSideBar:(330 / window.innerWidth) * 100});
      }
    } else if((this.state.isMenuOpen === false)) {
      this.setState({ widthSideBar: 1 });

    }
  }

  async toggleMenu() {
    await this.setState({ isMenuOpen: !this.state.isMenuOpen });
    this.resultSlider()
  }
  render() {
    const isMenuOpen = this.state.isMenuOpen
    return (
      <>
      <div className={`${isMenuOpen&&"blk-over"}`}></div>
        <Menu
          isMenuOpen={this.state.isMenuOpen}
          onMenuToggle={this.toggleMenu}
        />
        <Container>
          <Row>
            <div
              className={`collabse-result_${
                this.state.isMenuOpen === true ? "open" : "close"
              }`}
              style={{ marginLeft: `${this.state.widthSideBar}%` }}
              
            >
              <button type="button" onClick={this.toggleMenu}>
                Toggle Menu
              </button>
              <NavTab display="none" position="fixed" />
              <div className="container d-flex flex-column align-items-center">
              <AnnounceRow
                img="/imgs/hotelGallery/hotel1.png"
                imgWidth="25%"
                title="Vol Omra - Titre de l'offre"
                description="Hello word"
                prix="12 000"
                rating
                link="/visas/:id_visa/details"
                promotion
                contact
                details
                favoris
                addPanier
                announceDetails="Lorem Ipsum is simply text offf the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy when an unknown printer took a galley of type and scrambled it to make a type specimen book."
              />
              <AnnounceRow
                img="/imgs/Visa/eVisa.png"
                imgWidth="25%"
                title="Vol Omra - Titre de l'offre"
                description="Hello word"
                prix="12 000"
            
                rating
                contact
                details
                favoris
                addPanier
                
              />
               <AnnounceRow
                img="/imgs/hotelGallery/hotel1.png"
                imgWidth="25%"
                title="Vol Omra - Titre de l'offre"
                description="Hello word"
                prix="12 000"
                rating
                link="/visas/:id_visa/details"
                promotion
                contact
                details
                favoris
                addPanier
                announceDetails="Lorem Ipsum is simply text offf "
              />
              <AnnounceRow
                img="/imgs/hotelGallery/hotel1.png"
                imgWidth="25%"
                title="Vol Omra - Titre de l'offre"
                description="Hello word"
                prix="12 000"
                rating
              
                contact
                details
                favoris
                addPanier
                announceDetails="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy when an unknown printer took a galley of type and scrambled it to make a type specimen book."
              />
              <AnnounceRow
                img="/imgs/announces/index.png"
                imgWidth="25%"
                title="Vol Omra - Titre de l'offre"
                description="Hello word"
                prix="12 000"
                rating
                link="/visas/:id_visa/details"
                promotion
                contact
                details
                favoris
                addPanier
                announceDetails="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy when an unknown printer took a galley of type and scrambled it to make a type specimen book."
              />
              <AnnounceRow
                img="/imgs/announces/index.png"
                imgWidth="25%"
                title="Vol Omra - Titre de l'offre"
                description="Hello word"
                prix="12 000"
                rating
                link="/visas/:id_visa/details"
                promotion
                contact
                details
                favoris
                addPanier
                announceDetails="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy when an unknown printer took a galley of type and scrambled it to make a type specimen book."
              />
              </div>
            </div>
            <div className="app-container"></div>
          </Row>
        </Container>
      </>
    );
  }
}

export default AdvencedSearchVisa;
